const MODEL_NAME = 'platform'
export default [
  {
    path: `/${MODEL_NAME}/sold-out`,
    name: 'sold-out',
    component: () =>
      import(/* webpackChunkName: "platform-sold-out" */ '@pages/platform/soldOut.vue')
  },
  {
    path: `/${MODEL_NAME}/independent-service`,
    name: 'independent-service',
    component: () =>
      import(
        /* webpackChunkName: "platform-independent-service" */ '@pages/platform/independent-service.vue'
      )
  }
]
